import { render, staticRenderFns } from "./memberRecycleBin.vue?vue&type=template&id=c0024b36&scoped=true&"
import script from "./memberRecycleBin.vue?vue&type=script&lang=js&"
export * from "./memberRecycleBin.vue?vue&type=script&lang=js&"
import style0 from "./memberRecycleBin.vue?vue&type=style&index=0&id=c0024b36&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0024b36",
  null
  
)

export default component.exports